import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { TypeListItem } from "../TypeListItem/index.mjs";
import styled from "../../styled-components.mjs";
export var PopoverNavigationItemElement = styled(TypeListItem).attrs({
  variant: 'viola',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "PopoverNavigationItem__PopoverNavigationItemElement",
  componentId: "sc-1w8ibku-0"
})([""]);

/**
* **PopoverNavigationItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigationItem) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=291:1143)
*
* A list item that renders links or other content in the PopoverNavigationItem
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/popover?format=figma-figma#popovernavigation)
*
* @example
* () => <PopoverNavigationItem>List item</PopoverNavigationItem>;
*
*/
export var PopoverNavigationItem = /*#__PURE__*/React.forwardRef(function PopoverNavigationItem(_ref, ref) {
  var as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PopoverNavigationItemElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    "data-encore-id": ENCORE_DATA_IDS.PopoverNavigationItem
  }));
});